module.exports = __webpack_public_path__ + "media/images/location-e32dce005b0bfd1713bce4367334aa89.png";